import React, { Component } from 'react';

type Props = {
    onClick: (checked: boolean) => void
    checked: boolean;
    label?: string;
    disabled?: boolean;
    id?: string;
};

export class FstyrCheckbox extends Component<Props> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    handleChangeCheckBox = (event: any) => { this.props.onClick(event.target.checked) };

    render() {
        return (
            < div style={this.props.disabled ? { opacity: 0.5 } : {}}>
                <input
                    id={this.props.id ?? this.props.label}
                    type="checkbox"
                    checked={this.props.checked}
                    className="form-checkbox"
                    onChange={this.props.disabled ? () => { } : this.handleChangeCheckBox}
                    style={this.props.disabled ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}
                    disabled={this.props.disabled}
                />
                <label htmlFor={this.props.id ?? this.props.label}>{this.props.label ?? ""}</label>
            </div>
        );
    }
}